import { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { closeModal } from '@stores/actions/modal.action';
import { ModalStore, RootState } from '@stores/models/store';
import OverrideTheme from 'themes/custom-theme-helper';

import ModalWithConfetti from './ModalWithConfetti';
import SimpleDrawer from './SimpleDrawer';
import SimpleModal from './SimpleModal';

const Modal = (): ReactElement => {
  const dispatch = useDispatch();
  const location = useLocation();
  const modal = useSelector<RootState, ModalStore>((state) => state.modal);

  useEffect(() => {
    if (modal.show) {
      dispatch(closeModal());
    }
  }, [location.pathname]);

  const useStyles = makeStyles((theme: Theme) => ({
    modalContainer: {
      maxWidth: 600,
    },
    cardContainer: {
      minWidth: 500,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      height: '100%',
      paddingTop: 0,
    },
    cardContent: {
      overflow: 'auto',
      height: (modal.withHeader && 'calc(100% - 72px)') || '100%',
    },
    closeIcon: {
      color: OverrideTheme.colors.primary,
      marginRight: 10,
    },
    successIcon: {
      marginRight: 8,
    },
    confettiWrapper: {
      position: 'fixed',
      width: '100vw',
      height: '100vh',
      top: '0',
      left: '0',
      zIndex: '10000',
      pointerEvents: 'none',
    },
  }));

  const classes = useStyles();

  if (modal.type === 'dialog') {
    return <SimpleModal modal={modal} classes={classes} />;
  } else if (modal.type === 'confetti-dialog') {
    return <ModalWithConfetti modal={modal} classes={classes} />;
  }

  return <SimpleDrawer modal={modal} classes={classes} />;
};

export default Modal;
